import { useEffect, useRef } from "react";
/**
 * 执行验证码获取倒计时的逻辑
 * @param timer timer函数
 * @param timerEnd 倒计时结束时触发
 * @param total 倒计时总时间
 * @param run 是否运行倒计时
 *
 */
export function useCountDown(timer, timerEnd, total = 60, run = false) {
    // Ref用来保证函数不可能成为Effect依赖
    const timerRef = useRef(null);
    const timerEndRef = useRef(null);
    useEffect(() => {
        timerRef.current = timer;
        timerEndRef.current = timerEnd;
    });
    // 副作用的依赖列表只有total和run
    useEffect(() => {
        if (run) {
            let timeLeft = total;
            const inter = window.setInterval(() => {
                if (timeLeft <= 1) {
                    window.clearInterval(inter);
                    timerEndRef.current();
                    return;
                }
                timerRef.current(--timeLeft);
            }, 1000);
            return () => {
                window.clearInterval(inter);
            };
        }
    }, [total, run]);
}
